/* eslint-disable @typescript-eslint/no-explicit-any */
export const pageToOffset = (pageNumber = 1, limit: any) => {
  return (pageNumber - 1) * limit;
};
